<template>
  <div class="preview-page-header">
    <q-img
      class="preview-page-header__logo"
      src="/public/ki-logo.svg"
      height="70px"
      width="70px"
    />
  </div>
</template>

<script>

export default {
  name: 'PreviewPageHeader',
};
</script>

<style scoped lang="scss">

.preview-page-header {
  position: fixed;
  top: 65px;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
